export * from './user-dialog-header';
export * from './tenant-status-icon';
export * from './tenant-item';

import { UserDialogHeaderComponent } from "./user-dialog-header";
import { TenantStatusIconComponent } from './tenant-status-icon';
import { TenantItemComponent } from './tenant-item';

export const UserDialogAtoms = [
	UserDialogHeaderComponent,
	TenantStatusIconComponent,
	TenantItemComponent,
];